/**
 * @file This file contains the PageLoader component which indicates the loading state of the page or a process.
 * It uses Material-UI components to render a styled box containing an Essentia logo gif centered on the page.
 */
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import logoWebm from '../assets/load.webm';

const StyledBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
});

/**
 * Renders a full-page overlay with a centrally placed circular progress bar. It can be used to indicate that
 * the application is in the process of loading or processing data.
 */
const PageLoader = () => {
    return (
        <StyledBox aria-label='Loading' id='pageLoader'>
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{ width: '80px', height: '80px' }}
            >
                <source src={logoWebm} type='video/webm' />
                Your browser does not support the video tag.
            </video>
        </StyledBox>
    );
};

export default PageLoader;
